<template>
  <article class="kadenze-course-card kd-card kd-card--course-card">
    <div class="kd-card--course-card__discount-container" v-if="showDiscount">
      <span class="kd-card--course-card__discount-amount">
        {{course.discount}} OFF!
      </span>
    </div>

    <div class=" kd-card__entry-thumb">
      <a @click="courseAction" :href="courseActionLink" class="kd-card__entry-thumb_link" data-skip-pjax="true" aria-hidden="true" tabindex="-1">  
        <span class="sr-only">{{ course.full_name }}</span>

        <div class="kd-card__img_hover-overlay">
          <i class="kf kf-eye"></i>
        </div>
      </a>

      <img :src="course.logo" alt="Image" class="kd-card__img img-responsive">
    </div>
    <header class="kd-card__info">
      <a @click="courseAction" :href="courseActionLink" class="kd-card__info_course-title" aria-hidden="false" tabindex="-1" data-skip-pjax="false">
        <span v-tooltip="{content: course.full_name}" v-html="course.truncated_title">{{ course.truncated_title }}</span>
        <span class="m-icon" v-html="require('!html-loader!images/svg/microcourse_logo_large.svg')"></span>

      </a>
      <div class="kd-card-star-main">
        <div class="kd-card__info_instructors" v-if="course.first_instructor">
          {{ instructorsText }}
          <div class="kd-instructor_logo" v-if="!course.default_instructor_image">
            <a :href="course.profile_path" v-tooltip="{content: course.instructor_string}">
              <img :src="course.instructor_image" alt="Image" class="kd-card__img img-responsive">
            </a>
          </div>         
        </div>

        <div class="kd-star">
          <a :href="course.review_all_url" target="_blank" class="rating pull-right" v-if="course.full_stars > 0">
            <span v-for="rating in course.full_stars"><i class="orange-color kf kf-star"></i></span>
            <span v-if="course.half_star"><i class="kf kf-star half-star" style="background-image: linear-gradient(-90deg, #4b5253 50%, #ffa500 50%);"></i></span>
            <span v-for="rating in course.gray_stars"><i class="kf kf-star gray-star"></i></span>
          </a>
        </div>
      </div>

      <div class="ml1 reg">Kadenze Academy</div>
    </header>

    <footer class="kd-card__footer">
      <div class="kd-card__info_school kd-card__footer_secondary bold">
        <span class="chili-icon" v-if="isStudentRecentlyEnrolled" v-tooltip="{content: i18nTranslations('dict.popular')}">
          <span v-html="require('!html-loader!images/icons/chili.svg')"></span>
        </span>
        <span v-if="hasEnrollments()" v-tooltip="{content: totalEnrolled()}">
          <i class="kf kf-users course-card-icon-color" aria-hidden="true"></i>
          <span class="bold">{{ course.enrolled_student_count_floored }}</span>
        </span>
      </div>

      <div class="kd-card__footer_primary">
        <div class="signal-bars sizing-box good four-bars signal-expert" :class=skillLevelClass() v-if='skillLevel'>
          <div class="first-bar bar"></div>
          <div class="second-bar bar"></div>
          <div class="third-bar bar"></div>
        </div>
        <span class="ml-0" tabindex="-1" data-skip-pjax="true" v-if='skillLevel'>
          <span class="text-capitalize bold">{{ course.skill_level }}</span>
        </span>
      </div>
      <a href="javascript:;" aria-label="Share" @click="share" v-tooltip="{content: 'Share'}" class="kd-ibtn share-icon" aria-hidden="true" tabindex="-1">
        <i class="kf kf-share"></i>
      </a>
    </footer>
  </article>
</template>

<script type="text/javascript">
export default {
  name: "CourseCard",

  props: ['course', 'showUserStatus', 'publicBrowseEnabled'],

  computed: {
    upcoming() {
      return this.course.is_upcoming || this.course.is_pending;
    },

    archived() {
      if (this.course.current_user) {
        return this.course.is_ended || this.course.current_user.is_archived;
      } else {
        return this.course.is_ended;
      }
    },

    pending() {
      return this.course.is_pending;
    },

    enrolled() {
      return this.course.current_user && this.course.current_user.is_enrolled;
    },

    locked() {
      return this.course.current_user.is_locked;
    },

    is_instructor_or_admin() {
      return this.course.current_user.is_instructor || this.course.current_user.is_admin
    },

    showDiscount() {
      return ((typeof(this.course.current_user) == 'undefined') || !this.enrolled) && 
        this.course.discount && 
          (this.course.micro_course || 
            (this.course.in_program && this.course.program_only) || 
              this.course.standard_course);
    },

    courseActionLink() {
      let path = this.course.course_info_path;

      if (this.course.current_user) {
        if (this.course.current_user.is_student) {
          if (this.archived || this.upcoming) {
            path = this.course.course_info_path;
          } else if (!this.locked && !this.course.is_cohort_locked) {
            path = this.course.course_path;
          }
        } else if (this.is_instructor_or_admin) {
          path = this.course.course_path;
        }
      }

      return path;
    },

    instructorsText() {
      if(this.course.first_instructor) {
        return this.course.instructors_count > 1 ? `${this.course.first_instructor}...` : this.course.first_instructor;
      }
    },

    isMicroCourse() {
      return this.course.micro_course;
    },

    isStudentRecentlyEnrolled() {
      return this.course.student_recently_enrolled;
    },

    shareModalParams() {
      return {
        modal_title: 'Share Course',
        shareableObj: {
          id: this.course.id,
          title: this.course.name,
          description: this.course.description,
          share_url: this.course.course_share_url
        },
        emailShareCb: this.shareCourse
      };
    },

    skillLevel() {
      return this.course.skill_level;
    }
  },

  methods: {
    courseAction(e) {
      if (this.course.current_user && (this.course.is_cohort_locked || this.course.current_user.is_locked)) {
        if (this.course.is_cohort_locked) {
          if (moment().isAfter(this.course.next_cohort_occurrence)) {
            this.course.is_cohort_locked = false;
            return;
          } else {
            this.$emit('locked-cohort', this.course)
          }
        } else if (this.course.current_user.is_locked) {
          if (this.course.prerequisite_courses.length > 0) {
            this.$emit('course-locked', this.course)
          } else {
            this.$emit('course-unlock', this.course)
          }
        }
        setTimeout(NProgress.done, 100);
        if (e) {
          e.preventDefault();
        }
      }
    },

    share() {
      this.$emit('share', this.shareModalParams)
    },

    shareCourse(item, emails) {
      let url = Kadenze.Routes.share_course_path(item.id, {emails: emails});
      let method = 'PATCH';

      Kadenze.UIUtil.makeRequest(url, method, null, parent.$el, null, function (data, textStatus, xhr) {
        new Kadenze.Notice.success(data);
      }, function (xhr, textStatus, errorThrown) {
        new Kadenze.Notice.error(xhr.responseJSON);
      });
    },

    i18nTranslations(text) {
      return I18n.t(text);
    },

    skillLevelClass() {
      if(this.skillLevel){
        return `signal-${this.skillLevel.toLowerCase()}`;
      }
    },

    totalEnrolled(){
      var text = this.singleEnrollment() ? 'dict.student' : 'dict.students';
      return `${this.course.enrolled_student_count} ${this.i18nTranslations(text)}`;
    },

    singleEnrollment(){
      return this.enrollmentsCount() == 1;
    },

    enrollmentsCount() {
      return this.course.enrolled_student_count;
    },

    hasEnrollments() {
      return this.enrollmentsCount() > 0;
    },
  },

  mounted() {
    if (this.course.trigger_course_action) {
      this.courseAction();
    }
  }
}
</script>
